import { QueryResult, QueryConfig } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";
import { CajaMovimiento } from "@/shared/types/caja-movimiento";

export async function getCajaActualAperturaActualMovimiento(id: string): Promise<CajaMovimiento> {
    await sleep(1000);
    const response = await api.get("caja_actual/open/details/" + id);
    return response.data;
}

export function useGetCajaActualAperturaActualMovimientoQuery(id: string, queryConfig: QueryConfig<CajaMovimiento> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getCajaActualAperturaActualMovimiento(id),
        queryKey: ["caja_actual", "open", "details", id],
    })
}

export interface GetCajaActualAperturaActualMovimientoQueryProps {
    id: string,
    queryConfig?: QueryConfig<CajaMovimiento>,
    children?: (queryResult: QueryResult<CajaMovimiento>) => ReactNode
}

export function GetCajaActualAperturaActualMovimientoQuery({
    id,
    children,
    queryConfig
}: GetCajaActualAperturaActualMovimientoQueryProps) {
    const queryResult = useGetCajaActualAperturaActualMovimientoQuery(id, queryConfig);
    return children && children(queryResult);
}